import React, { useEffect, useState } from 'react';
import { StyleSheet } from 'react-native';

interface OrderCombinationOptionsMenuProps {
    onClose: () => void;
    onAddNote: () => void;
    onAddDiscount: () => void;
}

const OrderCombinationOptionsMenu: React.FC<OrderCombinationOptionsMenuProps> = ({ onClose, onAddNote, onAddDiscount }) => {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

 
    useEffect(() => {
        const handleResize = () => {
            console.log("onresize: innerWidth: " + window.innerWidth + "innerHeight: " + innerHeight)
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.onresize = handleResize;

        return () => {
            window.onresize = null;
        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
        };
    
        document.addEventListener("visibilitychange", handleVisibilityChange);
    
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        const updateSize = () => {
            console.log("update size")
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
    
        window.addEventListener("resize", updateSize);
        window.addEventListener("focus", updateSize);
        document.addEventListener("visibilitychange", updateSize);
    
        return () => {
            window.removeEventListener("resize", updateSize);
            window.removeEventListener("focus", updateSize);
            document.removeEventListener("visibilitychange", updateSize);
        };
    }, []);

    const styles = StyleSheet.create({
        popup: {
            width: windowSize.width > 900 ? windowSize.width * 0.40 : windowSize.width * 0.9,
            backgroundColor: '#fff',
            position: 'absolute',
            zIndex: 1000,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
    });

    return (
        <div style={styles.popup} className='ds-pop ds-pop--center'>
            <div className='d-flex px-3 pt-3 justify-content-end'>
                <button className='text-btn p-0 m-0 d-flex justify-content-center' onClick={onClose}>
                    <svg width="10" height="10" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 1L1 13M1 1L13 13" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div className='px-4 pb-3'>
                <h5>Order Options</h5>
                <div className='border-box p-2 mt-2 d-flex justify-content-between'>
                    <div className='d-flex gap-2 align-items-center' >
                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 2H5.8C4.11984 2 3.27976 2 2.63803 2.32698C2.07354 2.6146 1.6146 3.07354 1.32698 3.63803C1 4.27976 1 5.11984 1 6.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19H13.2C14.8802 19 15.7202 19 16.362 18.673C16.9265 18.3854 17.3854 17.9265 17.673 17.362C18 16.7202 18 15.8802 18 14.2V11M18.1213 1.87868C19.2929 3.05025 19.2929 4.94975 18.1213 6.12132C16.9497 7.29289 15.0503 7.29289 13.8787 6.12132C12.7071 4.94975 12.7071 3.05025 13.8787 1.87868C15.0503 0.707107 16.9497 0.707107 18.1213 1.87868Z" stroke="#475467" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <label className='d-flex align-items-center'>Add Note</label>
                    </div>
                    <button className='blue-filled-btn' onClick={onAddNote}>Select</button>
                </div>
                <div className='border-box p-2 mt-2 d-flex justify-content-between'>
                    <div className='d-flex gap-2 align-items-center'>
                        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 8H8.01M14 14H14.01M15 7L7 15M8.5 8C8.5 8.27614 8.27614 8.5 8 8.5C7.72386 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.72386 7.5 8 7.5C8.27614 7.5 8.5 7.72386 8.5 8ZM14.5 14C14.5 14.2761 14.2761 14.5 14 14.5C13.7239 14.5 13.5 14.2761 13.5 14C13.5 13.7239 13.7239 13.5 14 13.5C14.2761 13.5 14.5 13.7239 14.5 14ZM21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="#475467" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <label className='d-flex align-items-center'>Add Discount</label>
                    </div>
                    <button className='blue-filled-btn' onClick={onAddDiscount}>Select</button>
                </div>
            </div>
            <div className='p-2 d-flex justify-content-end' style={{ backgroundColor: '#F3F4F6' }}>
                <button className='white-filled-btn ' onClick={onClose}>Cancel</button>
            </div>
        </div>
    );
};

export default OrderCombinationOptionsMenu;

